<template>
  <v-col class="health mx-3">
    <bread-crumbs />

    <report-list v-if="showDashboard" />

    <v-row
      v-else
      class="health-report-content"
    >
      <v-col class="health-report">
        <data-table
          ref="table"
          :actions="actions"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import mixin from '../components/mixin'

const { mapGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'Health',
  components: {
    BreadCrumbs: () => import('@/layout/components/BreadCrumbs'),
    DataTable: () => import('@/tools/components/table/DataTable'),
    ReportList: () => import('@/dashboard/components/ReportList'),
  },
  mixins: [mixin],
  data() {
    return {
      actions: [
        {
          event: 'programmatic/openAdServerLink',
          name: 'GAM Deep Link',
        },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'currentColumns',
      'currentSummaries',
      'reportKey',
    ]),
    ...mapToolsState({
      filterData: (state) => state.filterData,
      items: (state) => state.items,
      reportId: (state) => state.reportId,
      reportName: (state) => state.reportName,
      selectedSearch: (state) => state.selectedSearch,
    }),
    showDashboard() {
      return this.selectedSearch?.dataType === 'custom'
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~src/styles/variables";

.health {
  display: flex;
  align-items: stretch;
  flex-direction: column;

  .loader {
    padding: 64px;
    align-self: center;
  }
}

.health-report-content {
  position: relative;
}

::v-deep.filter-link {
  margin-top: 8px;
}

::v-deep.filter-content {
  margin-top: 16px;
}

::v-deep.filter-label {
  padding-top: 20px;
}

</style>
